(function() {
  define('tlhComponentsEditableImage',['angular'], function() {
    'use strict';
    return angular.module('tlhComponentsEditableImage', []).directive('tlhEditableImage', [
      'TlhImageService', 'TlhNotificationService', function(TlhImageService, TlhNotificationService) {
        return {
          restrict: 'A',
          require: 'ngModel',
          scope: {
            maxWidth: '@'
          },
          link: function(scope, element, attrs, ngModel) {
            var input, readInput;
            if (scope.maxWidth == null) {
              scope.maxWidth = 1000;
            }
            if ('IMG' === element[0].tagName) {
              element.parent().addClass('tlh-editable-image-container');
            }
            input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = function() {
              TlhNotificationService.info({
                message: 'Importation de l\'image en cours...',
                delay: false
              });
              input = this;
              return TlhImageService.resizeInput(input, scope.maxWidth).then(function(result) {
                var imageData;
                imageData = {
                  url: result.dataUrl,
                  filename: result.filename,
                  mimeType: result.mimeType
                };
                readInput(imageData);
                return TlhNotificationService.success({
                  message: 'Importation terminée',
                  replaceMessage: true
                });
              })["catch"](function(error) {
                TlhNotificationService.warning({
                  message: 'Une erreur s\'est produite pendant l\'importation de l\'image, veuillez réessayer.',
                  replaceMessage: true
                });
                return console.log(error);
              });
            };
            element.on('click', function() {
              return input.click();
            });
            return readInput = function(imageData) {
              return ngModel.$setViewValue(imageData);
            };
          }
        };
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=editableImage.js.map
;
